import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
uploadImageDropzoneText: {
    id: 'course-authoring.certificates.modal-dropzone.text',
    defaultMessage: 'Przeciągnij i upuść swój obraz tutaj lub kliknij, aby przesłać',
    description: 'Opis bloku do przeciągania i upuszczania',
  },
  uploadImageDropzoneAlt: {
    id: 'course-authoring.certificates.modal-dropzone.dropzone-alt',
    defaultMessage: 'Przesłany obraz dla certyfikatu kursu',
    description: 'Opis dla przesłanego obrazu',
  },
  uploadImageValidationText: {
    id: 'course-authoring.certificates.modal-dropzone.validation.text',
    defaultMessage: 'Można przesłać tylko pliki typu {types}[cite: 1]. Wybierz plik z rozszerzeniem {extensions} do przesłania[cite: 2].',
    description: 'Komunikat o błędzie, gdy wybrany zostanie nieprawidłowy typ pliku',
  },
  cancelModal: {
    id: 'course-authoring.certificates.modal-dropzone.cancel.modal',
    defaultMessage: 'Anuluj',
    description: 'Tekst dla przycisku anulowania w oknie modalnym',
  },
  uploadModal: {
    id: 'course-authoring.certificates.modal-dropzone.upload.modal',
    defaultMessage: 'Prześlij',
    description: 'Tekst dla przycisku przesyłania w oknie modalnym',
  },
  uploadImageDropzoneInvalidSizeMore: {
    id: 'course-authoring.certificates.modal-dropzone.validation.invalid-size-more',
    defaultMessage: 'Rozmiar obrazu musi być mniejszy niż {maxSize}MB.',
    description: 'Komunikat o błędzie, gdy rozmiar przesłanego obrazu przekracza limit [cite: 3]',
  },
});

export default messages;
